import * as selectors from 'selectors'
import { createAction } from 'redux-actions'

const HIGHLIGHT_CURRENCY = 'totalbalance/dashboard/HIGHLIGHT_CURRENCY'
const SET_USER = 'totalbalance/dashboard/SET_USER'
const TOGGLE_PRESENTATION = 'totalbalance/dashboard/TOGGLE_PRESENTATION'
const PRESENT = 'totalbalance/dashboard/PRESENT'

const initialState = {
  userId: null,
  highlightedCurrencies: [],
  presentationRunning: false,
  presentationIndex: 0,
}

export default function config(state = initialState, action) {
  switch (action.type) {
    case HIGHLIGHT_CURRENCY:
      return {
        ...state,
        highlightedCurrencies: action.payload,
        presentationRunning: false,
      }
    case SET_USER:
      return {
        ...state,
        userId: action.payload,
      }
    case TOGGLE_PRESENTATION:
      return {
        ...state,
        highlightedCurrencies: [],
        presentationRunning: !state.presentationRunning,
      }
    case PRESENT:
      return {
        ...state,
        highlightedCurrencies: action.payload,
      }
    default:
      return state
  }
}

export const highlightCurrencies = createAction(HIGHLIGHT_CURRENCY)

export const setUser = createAction(SET_USER)

let presentationInterval
export const togglePresentation = () => (dispatch, getState) => {
  dispatch({ type: TOGGLE_PRESENTATION })
  const isRunning = getState().dashboard.presentationRunning
  if (isRunning) {
    let index = 0
    const funds = selectors.fundsWithValueMergedByCrypto(getState())
    dispatch({ type: PRESENT, payload: [funds[index].currency] })
    presentationInterval = setInterval(() => {
      if (!getState().dashboard.presentationRunning) {
        return clearInterval(presentationInterval)
      }
      index = (index + 1) % funds.length
      dispatch({ type: PRESENT, payload: [funds[index].currency] })
    }, 5000)
  } else {
    clearInterval(presentationInterval)
  }
}



// WEBPACK FOOTER //
// ./src/actions/dashboard.js